module.exports = __webpack_public_path__ + "static/img/25.5b47fd66.png";